import { ReactElement, useState } from 'react';
import { ExtendedTable } from 'common/components/ExtendedTable/ExtendedTable';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from 'common/constants/table.constants';
import { formatNumber } from 'common/utils/format.utils';
import {
  useGetCounterpartiesTableQuery,
} from 'domains/counterparties/queries/counterparty.query';
import { TCounterpartiesListResData } from 'domains/counterparties/types/counterparty.types';
import { getColumns } from './counterparties-table.columns';
import { ECounterpartiesTableColumns } from './counterparties-table.enum';

type TProps = {
  data: TCounterpartiesListResData;
};

type TPaginationConfig = {
  page: number,
  pageSize: number,
};

const CounterpartiesTableComponent = ({
  data,
}: TProps): ReactElement => {
  const [paginationData, setPaginationData] = useState<TPaginationConfig>({
    page: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
  });

  const redoCounterpartiesData = (redoData: TCounterpartiesListResData): any => {
    const tableData = (redoData?.counterparties ?? []).map((item) => ({
      ...item,
      reserve_acc: Math.floor(Math.random() * 1_000_000),
      emission_acc: Math.floor(Math.random() * 1_000_000),
      processing_acc: Math.floor(Math.random() * 1_000_000),
      total_amount: Math.floor(Math.random() * 1_000_000),
      issue: Math.floor(Math.random() * 1_000_000),
      burn: Math.floor(Math.random() * 1_000_000),
    }));

    return {
      originalResponse: data,
      tableData,
    };
  };

  const {
    data: counterpartiesData,
    isLoading: isCounterpartiesDataLoading,
  } = useGetCounterpartiesTableQuery(
    {
      limit: paginationData.pageSize,
      offset: (paginationData.page - 1) * paginationData.pageSize,
    },
    {
      initialData: data,
      select: redoCounterpartiesData,
      refetchOnMount: false,
    }
  );

  const columns = getColumns({
    formatNumber,
  });

  const handleCounterpartiesPaginationChange = (pageParam: number, pageSizeParam: number): void => {
    setPaginationData({
      page: pageParam,
      pageSize: pageSizeParam,
    });
  };

  const paginationConfig = {
    style: {
      marginRight: 30,
    },
    showQuickJumper: true,
    showSizeChanger: true,
    total: counterpartiesData?.originalResponse?.total || 0,
    pageSize: paginationData.pageSize,
    current: paginationData.page,
    onChange: handleCounterpartiesPaginationChange,
  };

  return (
    <ExtendedTable
      loading={isCounterpartiesDataLoading}
      pagination={paginationConfig}
      rowKey={ECounterpartiesTableColumns.Guid}
      dataSource={counterpartiesData?.tableData}
      columns={columns}
    />
  );
};

export default CounterpartiesTableComponent;
